import React from "react";
import { Updater } from "use-immer";

import { IgTypography } from "@intelligems/ig-theme";
import {
  ChannelType,
  ConversionStageReachedType,
  DeviceType,
  UserBehaviorFilterType,
  VisitorType,
} from "@intelligems/ig-types";
import { ConversionStageReachedFilter } from "@src/features/analytics/analyticsFilters/ConversionStageReachedFilter";
import { UserBehaviorViewsFilter } from "@src/features/analytics/analyticsFilters/UserBehaviorViewsFilter";

import { IExperienceDashboardFilters } from "@src/store/types/dashboardFilters";
import Stack from "@mui/material/Stack";

interface UserBehaviorFilter2Props {
  hasCheckoutBlocks: boolean;
  hasOnsiteUpsell: boolean;
  hasTestPostPurchase: boolean;
  userBehavior: UserBehaviorFilterType;
  setDialogFilters: Updater<IExperienceDashboardFilters>;
  onStringFilterChange: (
    newValue:
      | DeviceType
      | VisitorType
      | ChannelType
      | ConversionStageReachedType,
    filterKey:
      | "deviceType"
      | "channelType"
      | "visitorType"
      | "reachedCheckoutStage"
  ) => void;
  conversionStageReached: ConversionStageReachedType;
}
export const UserBehaviorFilter = ({
  hasCheckoutBlocks,
  hasOnsiteUpsell,
  hasTestPostPurchase,
  setDialogFilters,
  userBehavior,
  onStringFilterChange,
  conversionStageReached,
}: UserBehaviorFilter2Props) => {
  return (
    <Stack spacing={2}>
      <Stack spacing={1}>
        <IgTypography fontWeight={600}>Conversion Funnel</IgTypography>
        <ConversionStageReachedFilter
          conversionStageReached={conversionStageReached}
          hasCheckoutBlocks={hasCheckoutBlocks}
          hasOnsiteUpsell={hasOnsiteUpsell}
          hasTestPostPurchase={hasTestPostPurchase}
          onStringFilterChange={onStringFilterChange}
        />
      </Stack>
      <Stack spacing={1}>
        <IgTypography fontWeight={600}>Views</IgTypography>
        <UserBehaviorViewsFilter
          userBehavior={userBehavior}
          setDialogFilters={setDialogFilters}
        />
      </Stack>
    </Stack>
  );
};
